@if (items().length > 0) {
  <div class="relative inline-flex items-center">
    <!-- Discrete Header Icon Button / Chip Trigger -->
    <button
      mat-icon-button
      type="button"
      [matMenuTriggerFor]="reminderMenu"
      #menuTrigger="matMenuTrigger"
      (mouseenter)="menuTrigger.openMenu()"
      class="relative transition-transform duration-200 hover:scale-105 rounded-full flex items-center justify-center cursor-pointer"
      [class.text-ruby-11]="highestSeverity() === 'critical'"
      [class.bg-ruby-a3]="highestSeverity() === 'critical'"
      [class.hover:bg-ruby-a4]="highestSeverity() === 'critical'"
      [class.border]="highestSeverity() === 'critical'"
      [class.border-ruby-a6]="highestSeverity() === 'critical'"
      [class.text-amber-11]="highestSeverity() === 'warning'"
      [class.bg-amber-a3]="highestSeverity() === 'warning'"
      [class.hover:bg-amber-a4]="highestSeverity() === 'warning'"
      [class.border]="highestSeverity() === 'warning'"
      [class.border-amber-a6]="highestSeverity() === 'warning'"
      [class.text-indigo-11]="highestSeverity() === 'info'"
      [class.bg-indigo-a3]="highestSeverity() === 'info'"
      [class.hover:bg-indigo-a4]="highestSeverity() === 'info'"
      [class.border]="highestSeverity() === 'info'"
      [class.border-indigo-a6]="highestSeverity() === 'info'"
      [matTooltip]="
        items().length === 1 ? '1 information recommandée' : items().length + ' informations recommandées'
      "
    >
      <mat-icon class="text-base w-4 h-4">
        @switch (highestSeverity()) {
          @case ('critical') {
            priority_high
          }
          @case ('warning') {
            warning_amber
          }
          @default {
            info_outline
          }
        }
      </mat-icon>

      @if (items().length > 1) {
        <span
          class="absolute -top-1 -right-1 w-4 h-4 rounded-full text-[9px] font-black flex items-center justify-center shadow-xs"
          [class.bg-ruby-9]="highestSeverity() === 'critical'"
          [class.text-white]="highestSeverity() === 'critical'"
          [class.bg-amber-9]="highestSeverity() === 'warning'"
          [class.text-amber-1]="highestSeverity() === 'warning'"
          [class.bg-indigo-9]="highestSeverity() === 'info'"
          [class.text-white]="highestSeverity() === 'info'"
        >
          {{ items().length }}
        </span>
      }
    </button>

    <!-- Rich Popover / Dropdown Menu on Hover/Click -->
    <mat-menu
      #reminderMenu="matMenu"
      xPosition="before"
      class="max-w-sm rounded-2xl border border-gray-6 shadow-2xl p-0 overflow-hidden"
    >
      <div class="p-3 bg-gray-2 border-b border-gray-5 flex items-center justify-between gap-2">
        <div class="flex items-center gap-2">
          <div
            class="flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs"
            [class.bg-ruby-a3]="highestSeverity() === 'critical'"
            [class.text-ruby-11]="highestSeverity() === 'critical'"
            [class.bg-amber-a3]="highestSeverity() === 'warning'"
            [class.text-amber-11]="highestSeverity() === 'warning'"
            [class.bg-indigo-a3]="highestSeverity() === 'info'"
            [class.text-indigo-11]="highestSeverity() === 'info'"
          >
            <mat-icon class="text-xs w-3.5 h-3.5">
              @switch (highestSeverity()) {
                @case ('critical') {
                  priority_high
                }
                @case ('warning') {
                  warning_amber
                }
                @default {
                  info_outline
                }
              }
            </mat-icon>
          </div>
          <span class="text-xs font-bold text-gray-12">
            {{ items().length === 1 ? 'Information recommandée' : 'Informations recommandées' }}
          </span>
        </div>
        <span
          class="px-2 py-0.5 rounded-full text-[10px] font-bold tracking-tight"
          [class.bg-ruby-a3]="highestSeverity() === 'critical'"
          [class.text-ruby-11]="highestSeverity() === 'critical'"
          [class.bg-amber-a3]="highestSeverity() === 'warning'"
          [class.text-amber-11]="highestSeverity() === 'warning'"
          [class.bg-indigo-a3]="highestSeverity() === 'info'"
          [class.text-indigo-11]="highestSeverity() === 'info'"
        >
          {{ items().length }} point{{ items().length > 1 ? 's' : '' }}
        </span>
      </div>

      <div class="p-3 flex flex-col gap-2.5 max-h-80 overflow-y-auto">
        @for (item of items(); track item.id) {
          <div
            class="rounded-xl p-3 border transition-colors flex flex-col gap-2 shadow-2xs"
            [class.bg-ruby-1]="item.severity === 'critical'"
            [class.border-ruby-a6]="item.severity === 'critical'"
            [class.bg-amber-1]="item.severity === 'warning'"
            [class.border-amber-a6]="item.severity === 'warning'"
            [class.bg-indigo-1]="item.severity === 'info'"
            [class.border-indigo-a6]="item.severity === 'info'"
          >
            <div class="flex items-start gap-2.5">
              <mat-icon
                class="text-sm w-4 h-4 shrink-0 mt-0.5"
                [class.text-ruby-9]="item.severity === 'critical'"
                [class.text-amber-9]="item.severity === 'warning'"
                [class.text-indigo-9]="item.severity === 'info'"
              >
                {{ item.icon }}
              </mat-icon>
              <div>
                <div class="flex items-center gap-1.5 flex-wrap">
                  <h4 class="text-xs font-bold text-gray-12 m-0">{{ item.title }}</h4>
                </div>
                <p class="text-[11px] text-gray-11 m-0 mt-0.5 leading-relaxed">
                  {{ item.description }}
                </p>
              </div>
            </div>

            @if (!editMode()) {
              <div class="pt-1.5 border-t border-gray-5 flex justify-end">
                <button
                  mat-stroked-button
                  type="button"
                  (click)="onAction(item)"
                  class="text-[11px]! font-semibold! py-0.5! px-2.5! h-7! cursor-pointer flex items-center gap-1"
                  [class.border-ruby-7!]="item.severity === 'critical'"
                  [class.text-ruby-11!]="item.severity === 'critical'"
                  [class.hover:bg-ruby-3!]="item.severity === 'critical'"
                  [class.border-amber-7!]="item.severity === 'warning'"
                  [class.text-amber-11!]="item.severity === 'warning'"
                  [class.hover:bg-amber-3!]="item.severity === 'warning'"
                  [class.border-indigo-7!]="item.severity === 'info'"
                  [class.text-indigo-11!]="item.severity === 'info'"
                  [class.hover:bg-indigo-3!]="item.severity === 'info'"
                >
                  <span>{{ item.actionLabel }}</span>
                  <mat-icon class="text-xs! w-3! h-3! -mr-0.5">arrow_forward</mat-icon>
                </button>
              </div>
            }
          </div>
        }
      </div>
    </mat-menu>
  </div>
}
